<template>
  <SectionShell :icon="meta.icon || 'calendar'" :label="meta.label || fieldKey" :count="count">
    <div :style="{ display: 'flex', alignItems: 'center', gap: '7px', padding: '2px 2px 0' }">
      <input
        v-model="lo"
        :placeholder="ph"
        :style="rangeInput"
        @blur="commit(lo, hi)"
        @keydown.enter="commit(lo, hi)"
      >
      <span :style="{ fontSize: '11px', color: 'var(--p-surface-400)', fontFamily: mono }">TO</span>
      <input
        v-model="hi"
        :placeholder="ph"
        :style="rangeInput"
        @blur="commit(lo, hi)"
        @keydown.enter="commit(lo, hi)"
      >
      <button
        v-if="count > 0"
        title="Clear range"
        :style="{ background: 'transparent', border: 0, padding: '2px', cursor: 'pointer', color: 'var(--p-surface-400)', display: 'flex' }"
        @click="clearRange"
      >
        <i class="pi pi-times" :style="{ fontSize: '11px' }" />
      </button>
    </div>
    <div :style="{ padding: '6px 4px 0', fontSize: '10.5px', color: 'var(--p-surface-400)', fontFamily: mono }">
      {{ r ? `${fieldKey}:[${r.lower || '*'} TO ${r.upper || '*'}]` : 'open · use * for unbounded' }}
    </div>
  </SectionShell>
</template>

<script setup>
// Numeric range section (lo TO hi). Ported from fql-search.jsx RangeSection.
import { ref, computed, watch } from 'vue'
import { mono, rangeInput } from './bits.js'
import SectionShell from './SectionShell.vue'

const props = defineProps({
  fieldKey: { type: String, required: true },
  decl: { type: Object, default: () => ({}) },
  fieldSlot: { type: Object, required: true },
  meta: { type: Object, default: () => ({}) },
  search: { type: Object, required: true },
})

const r = computed(() => props.fieldSlot.range)
const lo = ref(r.value && r.value.lower ? r.value.lower : '')
const hi = ref(r.value && r.value.upper ? r.value.upper : '')
watch(
  () => [r.value && r.value.lower, r.value && r.value.upper],
  () => {
    lo.value = r.value && r.value.lower ? r.value.lower : ''
    hi.value = r.value && r.value.upper ? r.value.upper : ''
  },
)
function commit(nl, nh) {
  props.search.setRange(props.fieldKey, { lower: nl, upper: nh, includeLower: true, includeUpper: true })
}
const count = computed(() => (r.value ? 1 : 0))
const ph = computed(() => (props.decl.type === 'date' ? 'YYYY-MM-DD' : 'any'))
function clearRange() {
  lo.value = ''
  hi.value = ''
  props.search.clearField(props.fieldKey)
}
</script>
